var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMoney = function SvgMoney(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 15,
    "data-width-24": 22,
    viewBox: "0 0 14.8 11.1",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M10.446.6H1.831C1.15.6.6 1.151.6 1.83v4.924c0 .68.55 1.23 1.23 1.23h8.615c.68 0 1.231-.55 1.231-1.23V1.83c0-.68-.551-1.23-1.23-1.23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M14.138 3.062v6.153a1.23 1.23 0 0 1-1.23 1.231H3.062"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.139 6.139a1.846 1.846 0 1 0 0-3.693 1.846 1.846 0 0 0 0 3.693"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMoney);
export default ForwardRef;